import dayjs, { Dayjs } from "dayjs";
import { ordersForwardTab, ordersRtoTab } from "../../../common/data";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SelectChangeEvent } from "@mui/material";

// export const transportFilter = [
//   {
//     label: "All",
//   },
//   {
//     label: "Delhivery",
//   },
//   {
//     label: "Xpressbees",
//   },
//   {
//     label: "Bluedart",
//   },
// ];

// export const shipmentFilter = [
//   {
//     label: "Forward",
//     value: "forward",
//   },
//   {
//     label: "Rto",
//     value: "rto",
//   },
// ];

const useReturnFilter = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const pageParam = searchParams.get("page");
    const pageNumber = pageParam !== null ? parseInt(pageParam, 10) : 1;

    const startDateConstant =
        (searchParams.get("start-date") && dayjs(searchParams.get("start-date"))) ||
        dayjs().subtract(10, "day");
    const endDateConstant =
        (searchParams.get("end-date") && dayjs(searchParams.get("end-date"))) ||
        dayjs();

    const shipmentParams = searchParams.get("shipment") || "Forward";

    const status = shipmentParams === "Forward" ? "Ready to ship" : "In Transit";
    const tab = searchParams.get("status") || status;
    const transportParams = searchParams.get("transport") || "All";

    const defaultTab = shipmentParams === "Rto" ? ordersRtoTab : ordersForwardTab;

    //   let indexOfTransport = transportFilter.findIndex((data) => {
    //     return data.label === transportParams;
    //   });
    //   let indexOfShipment = shipmentFilter.findIndex((data) => {
    //     return data.label === shipmentParams;
    //   });

    let indexOfType = defaultTab.findIndex((data) => data.label === tab);

    //   indexOfTransport = indexOfTransport === -1 ? 0 : indexOfTransport;
    //   indexOfShipment = indexOfShipment === -1 ? 0 : indexOfShipment;
    indexOfType = indexOfType === -1 ? 0 : indexOfType;

    const [page, setPage] = useState<number>(pageNumber);
    const [totalRow, setTotalRow] = useState<number>(1);
    const [startDate, setStartDate] = useState<Dayjs | null>(startDateConstant);
    const [endDate, setEndDate] = useState<Dayjs | null>(endDateConstant);
    //   const [transport, setTransport] = useState(indexOfTransport);
    //   const [shipment, setShipment] = useState(indexOfShipment);
    const [activeTab, setActiveTab] = useState(indexOfType);

    // Handlers
    const updatePage = (event: React.ChangeEvent<unknown>, page: number) => {
        event.preventDefault();
        searchParams.set("page", `${page}`);
        setPage(page);
        setSearchParams(searchParams);
    };

    const handleTabChange = (
        _event: React.SyntheticEvent,
        newValue: any,
        shipment: string
    ) => {
        setActiveTab(newValue);
        searchParams.set("shipment", shipment);
        searchParams.set("status", defaultTab[newValue].label);
        searchParams.set("page", "1");
        setPage(1);
        setSearchParams(searchParams);
    };

    // const handleTransportChange = (event: SelectChangeEvent) => {
    //     const index = parseInt(event.target.value);
    //     setTransport(index);
    //     searchParams.set("transport", transportFilter[index].label);
    //     setSearchParams(searchParams);
    // };

    // const handleShipmentChange = (event: SelectChangeEvent) => {
    //     const index = parseInt(event.target.value);
    //     setShipment(index);
    //     searchParams.set("shipment", shipmentFilter[index].label);
    //     searchParams.set("status", index === 0 ? "Booked" : "Delivered");
    //     setSearchParams(searchParams);
    //     setActiveTab(0);
    // };

    const handleDateChange = (time: Dayjs | null, type: string) => {
        const date = time?.format("YYYY-MM-DD") || "";

        if (type === "start") {
            setStartDate(time);
            searchParams.set("start-date", date);
        } else {
            setEndDate(time);
            searchParams.set("end-date", date);
        }
        setSearchParams(searchParams);
    };

    return {
        startDate,
        endDate,
        page,
        // shipment,
        activeTab,
        defaultTab,
        setTotalRow,
        // transport,
        handleDateChange,
        // handleTransportChange,
        // handleShipmentChange,
        handleTabChange,
        shipmentParams,
        totalRow,
        updatePage,
    };
};

export default useReturnFilter;
